exports = module.exports = require("../../../../../../tools/web-builder/node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".loading-transformation-ad3{position:relative;top:50px}", "",{"version":3,"sources":["transformation-main.scss"],"names":[],"mappings":"AACA,4BACE,iBAAA,CACA,QAAA","file":"transformation-main.scss","sourcesContent":["\r\n.loading-transformation-ad3 {\r\n  position: relative;\r\n  top: 50px;\r\n}"]}]);

